export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8384.0aab6541.jpg";